import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import { CURRENCY_SYMBOLS, DEFAULT_CURRENCY } from '@/lib/config/currency';

interface CurrencyState {
  currency: string;
  symbol: string;
  hydrated: boolean;
  setCurrency: (currency: string) => void;
  setHydrated: (hydrated: boolean) => void;
}

export const useCurrency = create<CurrencyState>()(
  persist(
    (set) => ({
      currency: DEFAULT_CURRENCY,
      symbol: CURRENCY_SYMBOLS[DEFAULT_CURRENCY as keyof typeof CURRENCY_SYMBOLS],
      hydrated: false,
      setCurrency: (currency) => {
        const normalized = (currency || DEFAULT_CURRENCY).toUpperCase();
        set({ 
          currency: normalized,
          symbol: CURRENCY_SYMBOLS[normalized as keyof typeof CURRENCY_SYMBOLS] || '$'
        });
      },
      setHydrated: (hydrated) => set({ hydrated }),
    }),
    {
      name: 'currency-storage',
      onRehydrateStorage: () => (state) => {
        if (!state) return;

        const normalized = (state.currency || DEFAULT_CURRENCY).toUpperCase();
        state.currency = normalized;
        state.symbol = CURRENCY_SYMBOLS[normalized as keyof typeof CURRENCY_SYMBOLS] || '$';
        state.setHydrated(true);
      },
    }
  )
);
